export const themeHeading = "Select Some Themes That Interest You";
export const publicSpeakingText = "Public Speaking";
export const workLifeText = "Work-life-Balance";
export const businessComuText = "Business Communication";
export const riskAnalysisText = "Risk Analysis";
export const conflictText = "Conflict Management";
export const careerPathText = "Career Path";
